import { Chip, styled } from "@mui/material";

export const StyledChip = styled(Chip)<{ scope: number }>(
  ({ scope, theme: { palette } }) => ({
    color: palette.common.white,
    background:
      scope === 1
        ? palette.custom.teal[300]
        : scope === 2
          ? palette.custom.teal[600]
          : palette.custom.teal[900],
  }),
);
